import { onError as onApolloError } from "@apollo/client/link/error";
import { clearJWTToken } from "src/utils/auth";
import { SSO_AUTH_URL } from "src/constants/auth";

export type ErrorLinkProps = {
  onError?: (error: string) => void;
};

/**
 * Global GQL error handler
 */
export const getErrorLink = (options?: ErrorLinkProps) =>
  onApolloError(({ networkError }) => {
    const { onError } = options || {};

    if (networkError) {
      const statusCode = (networkError as any)?.statusCode;
      if (statusCode === 401) {
        clearJWTToken();
        window.location.href = SSO_AUTH_URL || "/";
      } else if (statusCode === 403) {
        onError?.("error.forbidden");
      }
    }
  });
